module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>'+
((__t=( headline ))==null?'':_.escape(__t))+
'</h1>\n';
}
return __p;
};
